module.exports = __webpack_public_path__ + "static/media/ja.92d0a926.png";